var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.459 8.8743L15.8333 7.49994L15.8334 7.49992C16.0679 7.26543 16.1851 7.14818 16.2696 7.03599C16.8056 6.32377 16.8056 5.34278 16.2696 4.63057C16.1851 4.51837 16.0679 4.40112 15.8334 4.16663L15.8333 4.16661L15.8333 4.16658C15.5988 3.9321 15.4816 3.81485 15.3694 3.73041C14.6572 3.19436 13.6762 3.19436 12.964 3.73041C12.8518 3.81485 12.7345 3.9321 12.5 4.16658L12.5 4.16661L11.1064 5.56023C11.9033 6.94047 13.06 8.08825 14.459 8.8743ZM9.6518 7.01482L4.18973 12.4769C3.76467 12.902 3.55214 13.1145 3.4124 13.3756C3.27267 13.6367 3.21372 13.9314 3.09583 14.5209L2.6471 16.7645C2.58058 17.0971 2.54732 17.2634 2.64193 17.358C2.73654 17.4526 2.90284 17.4194 3.23545 17.3529H3.23545L5.4791 16.9041C6.06855 16.7862 6.36328 16.7273 6.62437 16.5876C6.88547 16.4478 7.098 16.2353 7.52306 15.8102L13.0006 10.3327C11.6528 9.48191 10.5106 8.34748 9.6518 7.01482Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/edit_black.2f4ce5ca4d078e799f31a675c7b5c80b.svg";
export { ForwardRef as ReactComponent };